import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
const nomeMes = [
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ'
];

 class AssistenciaOdontoService extends Service {
  async consultarAnosPericia () {
    let anos = [];
    let result = await this.getAssistenciaOdontoApi().consultarAnosPericia();
    anos = result;
    return anos;
  }    
  async consultarNumPericias () {
    let pericias = [];
    let result = await this.getAssistenciaOdontoApi().consultarNumPericias();
    pericias = result;
    return pericias;
  }  
  async consultarReembolsos (ano, mes, numMatricula, codEstado, dataInicial, dataFinal, incluirNaoPagos) {
    let reembolsos = [];
    let brancoAcoes = '';
    let result = await this.getAssistenciaOdontoApi().consultarReembolsos(ano, mes, numMatricula, codEstado, dataInicial, dataFinal, incluirNaoPagos);
    result.map(res => {
      const { numProtocolo, anoPericia, numPericia, codServidor, seqDependenteRh, numMatricula, nomeBeneficiario, dtaPericiaInicio, dtaPericiaFim, dtaReembolso, dtaRecibo, pctReembolso, valRecibo, valReembolso, valPericia, valGlosado, valTotalOrcamento, valEmpenhado, codDentista, anoRemuneracao, mesRemuneracao, txtObservacao, indPagoFp, codTipoPag, dtaOrcamento, pctEmpenhado, indPeriodico, codEstado, desEstado, nomeDentista, txtProcessoSei, numCpfCgc, historicos } = res;
      let mesAnoPag = anoRemuneracao === 0 ? '-' : nomeMes[mesRemuneracao - 1] + '/' + anoRemuneracao;
      reembolsos.push(Object.values({ numProtocolo, anoPericia, numPericia, codServidor, seqDependenteRh, numMatricula, nomeBeneficiario, dtaPericiaInicio, dtaPericiaFim, dtaReembolso, dtaRecibo, pctReembolso, valRecibo, valReembolso, valPericia, valGlosado, valTotalOrcamento, valEmpenhado, codDentista, anoRemuneracao, mesRemuneracao, txtObservacao, indPagoFp, codTipoPag, dtaOrcamento, pctEmpenhado, indPeriodico, codEstado, desEstado, nomeDentista, txtProcessoSei, numCpfCgc, historicos, mesAnoPag, brancoAcoes }));
    });
    return reembolsos || [];
  }
  async incluirReembolso (reembolso) {
    let result = await this.getAssistenciaOdontoApi().incluirReembolso(reembolso);
    return result;
  }
  async alterarReembolso (reembolso) {
    let result = await this.getAssistenciaOdontoApi().alterarReembolso(reembolso);
    return result;
  }
  async excluirReembolso (numPericia, anoPericia) {
    let result = await this.getAssistenciaOdontoApi().excluirReembolso(numPericia, anoPericia);
    return result;
  }
  async consultarDentistas (CPF_CNPJ, nome) {
    let dentistas = [];
    const brancoAcoes = '';
    let result = await this.getAssistenciaOdontoApi().consultarDentistas(CPF_CNPJ, nome);
    result.map(res => {
      const { codDentista, nomDentista, numCro, numCpfCgc, numFone } = res;
      dentistas.push(Object.values({ codDentista, nomDentista, numCro, numCpfCgc, numFone, brancoAcoes }));
    });
    return dentistas || [];
  }  
  async consultarNomeDentista (CPF_CNPJ) {
    let result = await this.getAssistenciaOdontoApi().consultarNomeDentista(CPF_CNPJ);
    return result;
  }    
  async consultarNomeDentistaReceita (CPF_CNPJ) {
    let result = await this.getAssistenciaOdontoApi().consultarNomeDentistaReceita(CPF_CNPJ);
    return result;
  }    
  async incluirDentista (dentista) {
    let result = await this.getAssistenciaOdontoApi().incluirDentista(dentista);
    return result;
  }
  async alterarDentista (dentista) {
    let result = await this.getAssistenciaOdontoApi().alterarDentista(dentista);
    return result;
  }
  async excluirDentista (codDentista) {
    let result = await this.getAssistenciaOdontoApi().excluirDentista(codDentista);
    return result;
  }
}
export default AssistenciaOdontoService;
